<template>
  <div>
    <div style="height: 30vh">
      <v-card class="fill-height pa-0 overflow-hidden" rounded="0">
        <v-img
          :gradient="'to right, rgba(0,0,0,.5), rgba(0,0,0,.3)'"
          src="https://images.unsplash.com/photo-1533134486753-c833f0ed4866?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
          class="fill-width fill-height d-block"
        ></v-img>
        <v-card-text class="d-flex justify-space-between align-center fill-height absolute left center-y pa-0">
          <v-slide-y-transition mode="in-out">
            <v-container>
              <v-card class="banner-text" color="transparent" elevation="0">
                <div class="banner-title text-h4 text-md-h4 white--text font-weight-bold">
                  Add products directly from your whatsapp status
                </div>
              </v-card>
            </v-container>
          </v-slide-y-transition>
        </v-card-text>
      </v-card>
    </div>

    <v-container class="flex-grow-1 overflow-hidden mt-1">
      <div class="py-16 text-center" v-if="loading !== ''">
        <v-progress-circular color="primary" indeterminate size="25"></v-progress-circular>
        <div class="mx-auto mt-4" style="max-width: 300px">
          {{ loading }}
        </div>
      </div>
      <template v-else>
        <v-btn
          @click="bulkAdd()"
          v-if="multiple && selection.length" rounded class="px-4"
          dark color="primary" fixed bottom right elevation="0"
          style="position: fixed; right: 15px; bottom: 80px; z-index: 100"
        >
          Add {{ selection.length }} item(s)
        </v-btn>

        <template v-if="data.length">
          <div v-if="!multiple" class="d-flex align-center justify-space-between mb-5">
            <v-btn @click="multiple = true" color="grey lighten-1" small elevation="0" rounded class="px-4">
              <v-icon class="mr-2">mdi-format-list-checks</v-icon>
              Select multiple
            </v-btn>
          </div>
          <div v-else class="d-flex align-center mb-5">
            <v-btn @click="multiple = false" dark color="red lighten-1" small elevation="0" rounded class="px-4">
              <v-icon class="mr-2">mdi-close</v-icon>
              Cancel selection
            </v-btn>
          </div>
        </template>

        <div v-if="!data.length" class="d-flex flex-column justify-center align-center py-10 px-12 text-center">
          <img src="@/assets/images/empty-box.svg/" alt="" style="width: 200px"/>
          <div class="text-h6 font-weight-bold mt-6">You have not posted any status</div>
          <p class="text-body-1 mt-1">Statuses you post on your whatsapp will appear here</p>
        </div>

        <div v-for="(item, i) in data" :key="i" class="d-flex align-center">
          <v-checkbox
            v-if="multiple" :id="`${i}`" :value="selection.includes(`${i}`)"
            @change="handleSelectionChange(`${i}`, $event)"
          />
          <label :for="`${i}`" class="d-flex fill-width">
            <v-card
              class="position-relative flex-grow-1 rounded-lg d-flex flex-row align-center mb-2" light
              style="box-shadow: 0 4px 5px -1px rgba(0, 0, 0, .05); border: 1px solid rgba(0, 0, 0, .08)"
            >
              <div class="position-relative d-flex pa-2">
                <ProxyImage :src="item.image" width="100px"/>
              </div>
              <div class="px-3 py-3 px-md-4 flex-grow-1 d-flex flex-column align-start justify-center">
                <div class="text-title black--text text-body-2 mb-1 fill-width">
                  {{ item.caption || 'No caption' }}
                </div>
                <div v-if="!multiple" class="d-flex justify-space-between fill-width mt-2">
                  <v-btn @click="select(item)" color="grey lighten-3" elevation="0" small>
                    <v-icon class="mr-1" color="primary" size="12">mdi-cart-plus</v-icon>
                    Add to cart
                  </v-btn>
                </div>
              </div>
            </v-card>
          </label>
        </div>
      </template>
    </v-container>

    <br><br><br><br>

    <AddProductOptionsBottomNav/>

    <v-bottom-sheet v-model="visible" inset max-width="500" scrollable>
      <WhatsappStatusDetails v-if="current" :current="current" @done="handleAddDone()"/>
    </v-bottom-sheet>

    <v-snackbar :color="toast.color || ''" top v-model="toast.visible">
      {{ toast.message }}
    </v-snackbar>
  </div>
</template>

<script>
import ProxyImage from "@/components/ProxyImage";
import AddProductOptionsBottomNav from "@/components/standalone/merchants/AddProductOptionsBottomNav";
import WhatsappStatusDetails from "@/components/standalone/merchants/WhatsappStatusDetails";

export default {
  name: "MerchantAddProductsWhatsapp",
  components: { WhatsappStatusDetails, AddProductOptionsBottomNav, ProxyImage },
  data() {
    return {
      data: [],
      visible: false,
      toast: {
        visible: false,
        color: 'orange',
        message: ''
      },
      values: {
        name: '',
        price: '',
      },
      current: null,
      loading: '',
      adding: false,
      multiple: false,
      selection: []
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = 'Loading..';
      const res = await this.$http.get(`https://whatsapp.creditclan.com/merchant/status/${ this.$route.params.mid }`);
      this.data = res.data.data;
      this.loading = '';
    },
    select(item) {
      this.current = { ...item, values: { name: item.caption } };
      this.visible = true;
    },
    handleAddDone() {
      this.visible = false;
      this.current = null;
      this.toast = {
        visible: true,
        color: 'green',
        message: 'Product added successfully'
      }
    },
    handleSelectionChange(id, value) {
      if (value) {
        if (!this.selection.includes(id)) this.selection = [...this.selection, id];
      } else {
        if (this.selection.includes(id)) this.selection = this.selection.filter(i => i !== id);
      }
    },
    bulkAdd() {
      if (!this.selection.length) return;
      const items = this.selection.map(id => {
        return this.data[id];
      });
      console.log({ items });
    }
  }
}
</script>
